import Image from "next/image";

export default function faq() {
  return (
    <>
      <div 
     
      className="w-full h-auto mb-10  bd-crum"
      
      >
        <div className="   mx-auto px-20 py-20">
          <h2 className="py-12 text-3xl text-center text-white">Faq</h2>
        </div>
      </div>

      <div className="relative border-2 border-white  lg:w-11/12 mb-0 mx-8 lg:mx-12 shadow-white rounded  shadow-round-btn  overflow-hidden">
        <input
          type="checkbox"
          className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 cursor-pointer"
        />
        <div className="bg-black h-12  w-full  px-5 flex items-center">
          <h1 className="text-md text-white">Accordion 1 </h1>
        </div>

        <div className="absolute top-3 right-3 text-white transition-transform duration-500 rotate-0 peer-checked:rotate-180">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>

        <div
          className="bg-black text-white overflow-hidden transition-all duration-500 max-h-0 
        peer-checked:max-h-40"
        >
          <div className="p-4">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </p>
          </div>
        </div>
      </div>

      <div className="relative mt-3 lg:w-11/12  mx-8 lg:mx-12 border-2 border-white  shadow-white shadow-round-btn rounded overflow-hidden">
        <input
          type="checkbox"
          className="peer absolute top-0 inset-x-0 w-full h-12 opacity-0 z-10 cursor-pointer"
        />
        <div className="bg-black h-12  w-full  px-5 flex items-center">
          <h1 className="text-md text-white">Accordion 2 </h1>
        </div>

        <div className="absolute top-3 right-3 text-white transition-transform duration-500 rotate-0 peer-checked:rotate-180">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            className="w-5 h-5"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 8.25l-7.5 7.5-7.5-7.5"
            />
          </svg>
        </div>

        <div
          className="bg-black text-white overflow-hidden transition-all duration-500 max-h-0 
        peer-checked:max-h-40"
        >
          <div className="p-4">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
              eget.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
